import axios from "axios";
import { Transcript } from "../models/Transcript";
import { setNotification } from "../../store/notifications-reducer";
import { v4 } from "uuid";
import type { ShareAuthOptions } from "./conversations";

const buildAuthHeaders = ({ accessToken, shareLinkToken }: ShareAuthOptions): Record<string, string> => {
    const headers: Record<string, string> = {
        'X-Request-ID': v4()
    };

    if (accessToken) {
        headers['Authorization'] = accessToken;
    }

    if (shareLinkToken) {
        headers['X-PQ-Share-Link'] = shareLinkToken;
    }

    return headers;
};

// Async function to get the earnings transcript
export const getEarningsTranscript = async (
    ticker: string,
    fiscalDateEnding: string,
    auth: ShareAuthOptions,
    dispatch: (action: any) => void
): Promise<Transcript> => {
    const response = await axios.get(process.env.REACT_APP_API_URL + `/v1/stocks/${ticker}/transcripts/${fiscalDateEnding}`, {
        headers: buildAuthHeaders(auth)
    });

    if (response.status !== 200) {
        const err: any = new Error('Failed to get earnings transcript');
        err.httpCode = response.status;
        if (response.status === 403 && response?.data?.code === 1) {
            dispatch(setNotification({
                message: 'You do not have access to this earnings report. Please upgrade to premium to access all earnings.',
                type: 'error'
            }));
        }
        throw err;
    }

    return response.data as Transcript;
};
